import './App.css';
import Navbarfun from './Pages/Navbar';
import  Techskill  from './Pages/Techskill';
import AllRoutes from './MainRoutes/AllRoutes';
import Homepage from './Pages/Homepage';
import Mystory from './Pages/About';
import Projects from './Pages/Projects';
import Contact from './Pages/Contact';
import GithubStats from './Pages/GithubStats';
// import Resume from './Pages/Resume';

function App() {



  return (
    <>
    <Navbarfun />
    <Homepage />
   <Mystory />
   <Techskill />
   <Projects />
   <GithubStats />
<Contact />

    </>
  );
}

export default App;
